import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

const NotFound = () => {
  return React.createElement(
    'main',
    { className: 'page-content not-found' },
    React.createElement(
      'div',
      { className: 'container' },
      React.createElement('h1', null, '404'),
      React.createElement('h2', null, 'Page Not Found'),
      React.createElement('p', null, 'The page you are looking for does not exist.'),
      React.createElement(Link, { to: '/', className: 'btn-primary' }, 'Go Back Home')
    )
  );
};

export default NotFound;